import { useRef, useState } from "react";
import { UploadCloud, Camera, Loader2, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { t } from "@/i18n";

const STEPS = [t("dropzone.lecture_du_document"), t("dropzone.extraction_ia_des_produits_et_prix"), t("dropzone.rapprochement_des_ingredients"), t("dropzone.preparation_de_la_verification")];

export default function Dropzone({ onFile, busy, step }) {
  const [drag, setDrag] = useState(false);
  const fileRef = useRef(null);
  const camRef = useRef(null);

  const pick = (files) => files?.[0] && onFile(files[0]);

  return (
    <div
      data-testid="invoice-dropzone"
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => { e.preventDefault(); setDrag(false); if (!busy) pick(e.dataTransfer.files); }}
      className={`relative overflow-hidden rounded-2xl border-2 border-dashed p-8 text-center transition-colors sm:p-12 ${
        drag ? "border-emerald-500 bg-emerald-500/5" : "border-border bg-card/60"
      }`}
    >
      <div className="grid-bg pointer-events-none absolute inset-0 opacity-40 [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]" />
      <div className="relative">
        {busy ? (
          <div data-testid="invoice-ai-extract-status" className="flex flex-col items-center">
            <div className="mb-4 rounded-2xl bg-[hsl(var(--ai)/0.12)] p-4"><Loader2 className="h-7 w-7 animate-spin text-[hsl(var(--ai))]" /></div>
            <p className="text-base font-semibold">{STEPS[step % STEPS.length]}</p>
            <p className="mt-1 text-sm text-muted-foreground">{t("dropzone.cela_prend_generalement_10_a_30_secondes")}</p>
            <div className="mt-5 flex gap-1.5">
              {STEPS.map((_, i) => <span key={i} className={`h-1.5 w-8 rounded-full transition-colors ${i <= step % STEPS.length ? "bg-[hsl(var(--ai))]" : "bg-muted"}`} />)}
            </div>
          </div>
        ) : (
          <>
            <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl border bg-background"><UploadCloud className="h-6 w-6 text-emerald-500" /></div>
            <p className="text-lg font-semibold">{t("dropzone.deposez_votre_facture_fournisseur")}</p>
            <p className="mt-1 text-sm text-muted-foreground">{t("dropzone.pdf_jpg_png_heic_ou_photo_smartphone_15_mo")}</p>
            <div className="mt-6 flex flex-wrap justify-center gap-2">
              <Button onClick={() => fileRef.current?.click()} data-testid="invoice-upload-btn"><FileText className="mr-2 h-4 w-4" />{t("common.choisir_un_fichier")}</Button>
              <Button variant="outline" onClick={() => camRef.current?.click()} data-testid="invoice-camera-btn"><Camera className="mr-2 h-4 w-4" />{t("dropzone.prendre_une_photo")}</Button>
            </div>
          </>
        )}
        <input ref={fileRef} type="file" accept="application/pdf,image/*,.heic,.heif" className="hidden" data-testid="invoice-file-input" onChange={(e) => { pick(e.target.files); e.target.value = ""; }} />
        <input ref={camRef} type="file" accept="image/*" capture="environment" className="hidden" data-testid="invoice-camera-input" onChange={(e) => { pick(e.target.files); e.target.value = ""; }} />
      </div>
      {busy && <Loader2 className="hidden" />}
    </div>
  );
}
